import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisableButtonService {
  loaded = new Subject<boolean>();

  constructor() {
    // intentionally empty
  }

  enable() {
    this.loaded.next(true);
  }
}
